/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */

import { gql } from '@apollo/client'

import { ACTION_GENERATOR_STATS_FRAGMENT } from '@/graphql'

export const GET_ACTION_GENERATOR_STATS = gql`
  query GetActionGeneratorStats(
    $filters: ActionGeneratorsInput!
    $pagination: OffsetLimitPaginationFilter
  ) {
    actionGeneratorStats(filters: $filters, pagination: $pagination) {
      results {
        ...ActionGeneratorStats
      }
      totalCount
    }
  }
  ${ACTION_GENERATOR_STATS_FRAGMENT}
`
